import z from 'zod'

/** Declared in widget `package.json` → `lucimark.aspectRatioPolicy`. */
export const widgetAspectRatioPolicySchema = z.enum(['mandatory', 'optional'])

export type TWidgetAspectRatioPolicy = z.infer<typeof widgetAspectRatioPolicySchema>

/** Omitted or unknown values default to mandatory (legacy behaviour). */
export function normalizeWidgetAspectRatioPolicy(value: unknown): TWidgetAspectRatioPolicy {
  const r = widgetAspectRatioPolicySchema.safeParse(value)
  return r.success ? r.data : 'mandatory'
}

export function isWidgetAspectRatioOptional(policy: unknown): boolean {
  return normalizeWidgetAspectRatioPolicy(policy) === 'optional'
}

const ASPECT_RATIO_EPS = 1e-6

/**
 * True when section and reference widget dimensions have the same aspect ratio (within tolerance).
 * Uses ratio comparison so non-integer dimensions from package.json still match integer layout sections.
 */
export function sectionMatchesWidgetAspectRatio(
  section: { width: number, height: number },
  widgetWidth: number,
  widgetHeight: number
): boolean {
  if (section.width <= 0 || section.height <= 0 || widgetWidth <= 0 || widgetHeight <= 0) {
    return false
  }
  const rs = section.width / section.height
  const rw = widgetWidth / widgetHeight
  return Math.abs(rs - rw) <= ASPECT_RATIO_EPS
}
